import { Component, ElementRef, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { debounceTime, lastValueFrom } from 'rxjs';
import { MCommonBlogListModalRequest, MCommonListModalRequest } from 'src/app/utils/utils.service';
import { WsBlogService } from 'src/app/ws/wsBlog/ws-blog.service';
import { MCategoryResponseModal, MblogResponse } from './blog.module';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { MGetAllShopAllModuleDataResponse } from '../product/product.module';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent {
  blogs: any = []
  mCommonListModalRequest: MCommonBlogListModalRequest = new MCommonBlogListModalRequest()
  trendingBlogs: any = []
  skinCareBlogs: any = []
  decodeYourRoutineBlogs: any = []
  smartBeautyBlogs: any = []
  forMensBlogs: any = []
  hairBlogs: any = []
  bathBodyBlogs: any = []
  editorsPickBlogs: any = []
  mCategoryResponseModal: MCategoryResponseModal = new MCategoryResponseModal()
  mGetAllShopAllModuleDataResponse: MGetAllShopAllModuleDataResponse = new MGetAllShopAllModuleDataResponse()
  mBlogModalRequest: MCommonListModalRequest = new MCommonListModalRequest();
  foyBlogTv: any;
  count: any = 0
  skinCareSubCategories: any = []
  decodeYourRoutineSubCategories: any = []
  smartBeautySubCategories: any = []
  forMensSubCategories: any = []
  hairBlogSubCategories: any = []
  bathBodySubCategories: any = []
  hairSubCategories: any = []
  skinCareColor: any = '#fff';
  decodeYourRoutineColor: any = "#fff";
  smartBeautyColor: any = "#fff";
  forMensColor: any = "#fff";
  hairColor: any = "#fff";
  bathBodyColor: any = "#fff";
  forMensSubCategorySelected: any;
  hairSubCategorySelected: any;
  bathBodySubCategorySelected: any;
  smartBeautySubCategorySelected: any;
  decodeYourRoutineSubCategorySelected: any;
  skinCareSubCategorySelected: any;
  show: boolean = false;
  blogSearchForm!: FormGroup;
  mblogResponse: any = [];
  private storageKey = 'searchBlogHistory';
  searchHistory: any = null;
  arrSearchHistory: any = [];
  historyShow: any;
  share: any;
  baseUrl: any = window.location.origin;
  currentUrl: any;
  skinCatId: any;
  dyrCatId: any;
  beautyCatId: any;
  formensCatId: any;
  hairCatId: any;
  bbCatId: any;
  showtrendingBlogLeftArrow: boolean = true;
  showtrendingBlogRightArrow: boolean = true;
  @ViewChild('trendingblogs') trendingblogs!: ElementRef;
  showskincareoneLeftArrow: boolean = true;
  showskincareoneRightArrow: boolean = true;
  @ViewChild('skincareone') skincareone!: ElementRef;
  showdecodeLeftArrow: boolean = true;
  showdecodeRightArrow: boolean = true;
  @ViewChild('decode') decode!: ElementRef;
  showformenLeftArrow: boolean = true;
  showformenRightArrow: boolean = true;
  @ViewChild('formen') formen!: ElementRef;
  showsmartbeautyLeftArrow: boolean = true;
  showsmartbeautyRightArrow: boolean = true;
  @ViewChild('smartbeauty') smartbeauty!: ElementRef;
  showhairwegoLeftArrow: boolean = true;
  showhairwegoRightArrow: boolean = true;
  @ViewChild('hairwego') hairwego!: ElementRef;
  showeditorLeftArrow: boolean = true;
  showeditorRightArrow: boolean = true;
  @ViewChild('editor') editor!: ElementRef;
  showbathbodyLeftArrow: boolean = true;
  showbathbodyRightArrow: boolean = true;
  @ViewChild('bathbody') bathbody!: ElementRef;

  constructor(private _commonBehaviorChangeService: CommonBehaviorChangeService, private wsShopAllService: WsShopallService, private wsblogservice: WsBlogService, private router: Router, private sanitizer: DomSanitizer, private formBuilder: FormBuilder, private toast: ToastrService) {
    this.blogSearchForm = this.formBuilder.group({
      search: new FormControl('')
    })

    this.blogSearchForm.get('search')?.valueChanges.pipe(
      debounceTime(300)
    ).subscribe(() => {
      this.getBlogList();
    });
  }

  bTitle: OwlOptions = {
    loop: true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    margin: 0,
    autoplay: true,
    autoplayTimeout: 1000,
    dots: false,
    nav: false,
    items: 1,
  }

  blogSlider: OwlOptions = {
    loop: true,
    margin: 0,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 1000,
    dots: false,
    center: false,
    nav: true,
    navText: [
      '<span><img src="assets/images/arrow-long.svg" alt="icon" /></span>',
      '<span class="arrow-rotate"><img src="assets/images/arrow-long.svg" alt="icon" /></span>'
    ],
    responsive: {
      0: {
        items: 1.1,
        margin: 15,
      },
      576: {
        items: 2.1,
        margin: 15,
      },
      1024: {
        items: 2.1,
        margin: 30,
      },
      1250: {
        items: 3.1,
        margin: 30,
      },
      1600: {
        items: 3.1,
        margin: 30,
      }
    }
  }

  threeBoxSlider: OwlOptions = {
    loop: true,
    margin: 0,
    autoplay: false,
    autoplayTimeout: 1000,
    dots: false,
    nav: true,
    items: 2,
    navText: [
      '<span><img src="assets/images/arrow-right-w.svg" alt="icon" /></span>',
      '<span><img src="assets/images/arrow-left-w.svg" alt="icon" /></span>'
    ],
    responsive: {
      0: {
        items: 1.1,
        margin: 15,
      },
      576: {
        items: 2.1,
        margin: 15,
      },
      1024: {
        items: 2.1,
        margin: 30,
      },
      1250: {
        items: 3.1,
        margin: 30,
      },
      1600: {
        items: 3.1,
        margin: 30,
      }
    }
  }

  threeBoxSliderFull: OwlOptions = {
    loop: true,
    margin: 0,
    autoplay: false,
    autoplayTimeout: 1000,
    dots: false,
    nav: true,
    items: 2,
    navText: [
      '<span><img src="assets/images/box-left-arrow.svg" alt="icon" /></span>',
      '<span><img src="assets/images/box-right-arrow.svg" alt="icon" /></span>'
    ],
    responsive: {
      0: {
        items: 1.1,
        margin: 15,
      },
      576: {
        items: 2.1,
        margin: 15,
      },
      1024: {
        items: 2.1,
        margin: 30,
      },
      1250: {
        items: 3.1,
        margin: 30,
      },
      1600: {
        items: 3.1,
        margin: 30,
      }
    }
  }
  forBoxSliderFull: OwlOptions = {
    loop: true,
    margin: 0,
    autoplay: false,
    autoplayTimeout: 1000,
    dots: false,
    nav: true,
    items: 2,
    navText: [
      '<span><img src="assets/images/box-left-arrow.svg" alt="icon" /></span>',
      '<span><img src="assets/images/box-right-arrow.svg" alt="icon" /></span>'
    ],
    responsive: {
      0: {
        items: 1.1,
        margin: 15,
      },
      576: {
        items: 2.1,
        margin: 15,
      },
      1024: {
        items: 2.1,
        margin: 30,
      },
      1250: {
        items: 3.1,
        margin: 30,
      },
      1600: {
        items: 3.1,
        margin: 30,
      }
    }
  }
  fiveBoxSliderFull: OwlOptions = {
    loop: true,
    margin: 0,
    autoplay: false,
    autoplayTimeout: 1000,
    dots: false,
    nav: true,
    items: 2,
    navText: [
      '<span><img src="assets/images/box-left-arrow.svg" alt="icon" /></span>',
      '<span><img src="assets/images/box-right-arrow.svg" alt="icon" /></span>'
    ],
    responsive: {
      0: {
        items: 1.1,
        margin: 15,
      },
      576: {
        items: 2.1,
        margin: 15,
      },
      1024: {
        items: 2.1,
        margin: 30,
      },
      1250: {
        items: 3.1,
        margin: 30,
      },
      1600: {
        items: 3.1,
        margin: 30,
      }
    }
  }

  ngOnInit() {
    this.getCategoryList()
    document.addEventListener('click', this.toggleShareBox.bind(this));
    setTimeout(() => {
      this.checkAllArrow()
    }, 8000);
  }

  /**
   * Hide Share Box on outside click
   * @param event 
   */
  toggleShareBox(event: Event): void {
    const isInsideBlogIcon = (event.target as HTMLElement).closest('.blog-icon');
    const isSearchBlog = ((event.target as HTMLElement).closest('.blog-search-bar-new') || (event.target as HTMLElement).closest('.blog-filter-panel'));
    if (!isInsideBlogIcon) {
      this.share = null; // Hides the share box when clicked outside
    }
    if (!isSearchBlog) {
      this.show = false;
      this.historyShow = false;
    }
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.toggleShareBox.bind(this));
  }

  setSubCategory(catId: any, subId: any) {
    if (this.skinCatId && catId == this.skinCatId.category_code) {
      if (subId == this.mCommonListModalRequest.subcategoryid) {
        this.skinCareSubCategorySelected = null
        delete this.mCommonListModalRequest.subcategoryid
        this.getSkinCareBlogList(this.skinCatId.id);
      } else {
        this.skinCareSubCategorySelected = subId
        this.mCommonListModalRequest.subcategoryid = subId
        this.getSkinCareBlogList(this.skinCatId.id);
      }
    }
    if (this.dyrCatId && catId == this.dyrCatId.category_code) {
      if (subId == this.mCommonListModalRequest.subcategoryid) {
        this.decodeYourRoutineSubCategorySelected = null
        delete this.mCommonListModalRequest.subcategoryid
        this.getDecodeYourRoutineBlogList(this.dyrCatId.id);
      } else {
        this.decodeYourRoutineSubCategorySelected = subId
        this.mCommonListModalRequest.subcategoryid = subId
        this.getDecodeYourRoutineBlogList(this.dyrCatId.id);
      }
    }
    if (this.beautyCatId && catId == this.beautyCatId.category_code) {
      if (subId == this.mCommonListModalRequest.subcategoryid) {
        this.smartBeautySubCategorySelected = null
        delete this.mCommonListModalRequest.subcategoryid
        this.getSmartBeautyBlogList(this.beautyCatId.id);
      } else {
        this.smartBeautySubCategorySelected = subId
        this.mCommonListModalRequest.subcategoryid = subId
        this.getSmartBeautyBlogList(this.beautyCatId.id);
      }
    }
    if (this.bbCatId && catId == this.bbCatId.category_code) {
      if (subId == this.mCommonListModalRequest.subcategoryid) {
        this.bathBodySubCategorySelected = null
        delete this.mCommonListModalRequest.subcategoryid
        this.getBathBodyBlogList(this.bbCatId.id);
      } else {
        this.bathBodySubCategorySelected = subId
        this.mCommonListModalRequest.subcategoryid = subId
        this.getBathBodyBlogList(this.bbCatId.id);
      }
    }
    if (this.hairCatId && catId == this.hairCatId.category_code) {
      if (subId == this.mCommonListModalRequest.subcategoryid) {
        this.hairSubCategorySelected = null
        delete this.mCommonListModalRequest.subcategoryid
        this.getHairBlogList(this.hairCatId.id);
      } else {
        this.hairSubCategorySelected = subId
        this.mCommonListModalRequest.subcategoryid = subId
        this.getHairBlogList(this.hairCatId.id);
      }
    }
    if (this.formensCatId && catId == this.formensCatId.category_code) {
      if (subId == this.mCommonListModalRequest.subcategoryid) {
        this.forMensSubCategorySelected = null
        delete this.mCommonListModalRequest.subcategoryid
        this.getForMensBlogList(this.formensCatId.id);
      } else {
        this.forMensSubCategorySelected = subId
        this.mCommonListModalRequest.subcategoryid = subId
        this.getForMensBlogList(this.formensCatId.id);
      }
    }
  }

  getSearchHistory() {
    this.searchHistory = localStorage.getItem(this.storageKey);
    if (this.searchHistory != 'undefined' && this.searchHistory != null) {
      this.arrSearchHistory = JSON.parse(this.searchHistory)
    }
    return this.arrSearchHistory;
  }

  async getBlogList() {
    this.mBlogModalRequest.skip = 0;
    this.mBlogModalRequest.take = 1000;
    this.mBlogModalRequest.search = this.blogSearchForm.controls['search'].value;
    if (this.blogSearchForm.controls['search'].value.length > 0) {
      this.show = true;
      this.historyShow = false;
      const getBlogs = this.wsblogservice.getBlogList(this.mBlogModalRequest);
      await lastValueFrom(getBlogs).then(response => {
        if (response && response.statusCode == 200) {
          this.mblogResponse.data = response.data;
          this.mblogResponse.data = this.mblogResponse.data.filter((item: any) => {
            if (item?.is_active == false) {
              return false;
            }
            return true;
          })
        }
      })
    }
    else {
      this.show = false;
      this.mblogResponse.data = [];
    }
  }

  /**
  * to get category list
  */
  async getCategoryList() {
    const categoryListData = this.wsblogservice.getCategoryByType(2);
    await lastValueFrom(categoryListData).then(response => {
      if (response && response.statusCode == 200) {
        this.mCategoryResponseModal.data = response.data;
        this.mCategoryResponseModal.data = this.mCategoryResponseModal.data.filter((item: any) => {
          if (item?.is_active !== false) {
            return true;
          }
          return false;
        })
        this.getTrendingBlogList()
        this.getEditorsPickBlogList()

        this.skinCatId = this.mCategoryResponseModal.data.find((cat: any) => (cat.category_code == 'skinCare101'))
        if (this.skinCatId?.is_active !== false) {
          if (this.skinCatId?.id) {
            this.getSkinCareBlogList(this.skinCatId?.id);
            this.getAllModuleDataOfShopAll("" + this.skinCatId?.id, this.skinCatId?.category_code);
          }
        }

        this.dyrCatId = this.mCategoryResponseModal.data.find((cat: any) => (cat.category_code == 'decodeyourroutine'))
        if (this.dyrCatId?.is_active !== false) {
          if (this.dyrCatId?.id) {
            this.getDecodeYourRoutineBlogList(this.dyrCatId?.id);
            this.getAllModuleDataOfShopAll("" + this.dyrCatId?.id, this.dyrCatId?.category_code);
          }
        }

        this.beautyCatId = this.mCategoryResponseModal.data.find((cat: any) => (cat.category_code == 'smartbeauty'))
        if (this.beautyCatId?.is_active !== false) {
          if (this.beautyCatId?.id) {
            this.getSmartBeautyBlogList(this.beautyCatId?.id);
            this.getAllModuleDataOfShopAll("" + this.beautyCatId?.id, this.beautyCatId?.category_code);
          }
        }

        this.formensCatId = this.mCategoryResponseModal.data.find((cat: any) => (cat.category_code == 'MEN'))
        if (this.formensCatId?.is_active !== false) {
          if (this.formensCatId?.id) {
            this.getForMensBlogList(this.formensCatId?.id);
            this.getAllModuleDataOfShopAll("" + this.formensCatId?.id, this.formensCatId?.category_code);
          }
        }

        this.hairCatId = this.mCategoryResponseModal.data.find((cat: any) => (cat.category_code == 'hair'))
        if (this.hairCatId?.is_active !== false) {
          if (this.hairCatId?.id) {
            this.getHairBlogList(this.hairCatId?.id);
            this.getAllModuleDataOfShopAll("" + this.hairCatId?.id, this.hairCatId?.category_code);
          }
        }

        this.bbCatId = this.mCategoryResponseModal.data.find((cat: any) => (cat.category_code == 'BATH&BODY'))
        if (this.bbCatId?.is_active !== false) {
          if (this.bbCatId?.id) {
            this.getBathBodyBlogList(this.bbCatId?.id);
            this.getAllModuleDataOfShopAll("" + this.bbCatId?.id, this.bbCatId?.category_code);
          }
        }
      } else {
      }
    })
  }

  async getAllModuleDataOfShopAll(catId: any, catCode: any) {
    const getAllModuleDataOfShopAll = this.wsShopAllService.getAllModuleDataOfShopAll("" + catId)
    await lastValueFrom(getAllModuleDataOfShopAll).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetAllShopAllModuleDataResponse.data = response.data;
        if (this.mGetAllShopAllModuleDataResponse && this.mGetAllShopAllModuleDataResponse.data) {
          if (this.mGetAllShopAllModuleDataResponse.data['subCategoryList'].length > 0) {
            if (catCode == this.skinCatId?.category_code) {
              this.skinCareSubCategories = this.mGetAllShopAllModuleDataResponse.data['subCategoryList']
              this.skinCareSubCategories = this.skinCareSubCategories.filter((item: any) => {
                if (item?.is_active !== false) {
                  return true;
                }
                return false;
              })
            }
            if (catCode == this.dyrCatId?.category_code) {
              this.decodeYourRoutineSubCategories = this.mGetAllShopAllModuleDataResponse.data['subCategoryList']
              this.decodeYourRoutineSubCategories = this.decodeYourRoutineSubCategories.filter((item: any) => {
                if (item?.is_active !== false) {
                  return true;
                }
                return false;
              })
            }
            if (catCode == this.beautyCatId?.category_code) {
              this.smartBeautySubCategories = this.mGetAllShopAllModuleDataResponse.data['subCategoryList']
              this.smartBeautySubCategories = this.smartBeautySubCategories.filter((item: any) => {
                if (item?.is_active !== false) {
                  return true;
                }
                return false;
              })
            }
            if (catCode == this.bbCatId?.category_code) {
              this.bathBodySubCategories = this.mGetAllShopAllModuleDataResponse.data['subCategoryList']
              this.bathBodySubCategories = this.bathBodySubCategories.filter((item: any) => {
                if (item?.is_active !== false) {
                  return true;
                }
                return false;
              })
            }
            if (catCode == this.hairCatId?.category_code) {
              this.hairSubCategories = this.mGetAllShopAllModuleDataResponse.data['subCategoryList']
              this.hairSubCategories = this.hairSubCategories.filter((item: any) => {
                if (item?.is_active !== false) {
                  return true;
                }
                return false;
              })
            }
            if (catCode == this.formensCatId?.category_code) {
              this.forMensSubCategories = this.mGetAllShopAllModuleDataResponse.data['subCategoryList']
              this.forMensSubCategories = this.forMensSubCategories.filter((item: any) => {
                if (item?.is_active !== false) {
                  return true;
                }
                return false;
              })
            }
          }
        }
      } else {
      }
    })
  }

  /**
   * to get trending blog list
   */
  async getEditorsPickBlogList() {
    this.editorsPickBlogs = [];
    const editorsPickBlogs = this.wsblogservice.getBlogCataoryWiseWithAllFilter(null, true);
    await lastValueFrom(editorsPickBlogs).then(response => {
      if (response && response.statusCode == 200 && response.data) {
        response.data.forEach((blog: any) => {
          if (this.editorsPickBlogs.length < 1) {
            this.editorsPickBlogs = blog.blogs;
          } else {
            this.editorsPickBlogs = [...this.editorsPickBlogs, ...blog.blogs];
          }
        })
        this.editorsPickBlogs = this.editorsPickBlogs.filter((item: any) => {
          if (item?.is_active !== false) {
            return true;
          }
          return false;
        })
      } else {
      }
    })
  }

  /**
   * to get trending blog list
   */
  async getTrendingBlogList() {
    this.trendingBlogs = [];
    const trendingBlogs = this.wsblogservice.getBlogCataoryWiseWithAllFilter(true);
    await lastValueFrom(trendingBlogs).then(response => {
      if (response && response.statusCode == 200 && response.data) {
        response.data.forEach((blog: any) => {
          if (this.trendingBlogs.length < 1) {
            this.trendingBlogs = blog.blogs;
          } else {
            this.trendingBlogs = [...this.trendingBlogs, ...blog.blogs];
          }
        })
        this.trendingBlogs = this.trendingBlogs.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
        })
      } else {
      }
    })
  }

  /**
  * to get skin care Blog List  
  */
  async getSkinCareBlogList(catId: any) {
    this.mCommonListModalRequest.take = 6;
    this.mCommonListModalRequest.catagoryid = catId;
    this.skinCareBlogs = []
    const skinCareBlogs = this.wsblogservice.getAllBlogFilter(this.mCommonListModalRequest);
    await lastValueFrom(skinCareBlogs).then(response => {
      if (response && response.statusCode == 200) {
        this.skinCareBlogs = response.data;
        this.skinCareBlogs = this.skinCareBlogs.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
        })
        if (this.skinCareBlogs && this.skinCareBlogs.length > 0) {
          this.skinCareColor = this.skinCareBlogs[0].category.color;
        }
      } else {
      }
    })
  }

  /**
 * to get decode routine Blog List  
 */
  async getDecodeYourRoutineBlogList(catId: any) {
    this.mCommonListModalRequest.take = 6;
    this.mCommonListModalRequest.catagoryid = catId;
    this.decodeYourRoutineBlogs = []
    const decodeYourRoutineBlogs = this.wsblogservice.getAllBlogFilter(this.mCommonListModalRequest);
    await lastValueFrom(decodeYourRoutineBlogs).then(response => {
      if (response && response.statusCode == 200) {
        this.decodeYourRoutineBlogs = response.data;
        this.decodeYourRoutineBlogs = this.decodeYourRoutineBlogs.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
        })
        if (this.decodeYourRoutineBlogs && this.decodeYourRoutineBlogs.length > 0) {
          this.decodeYourRoutineColor = this.decodeYourRoutineBlogs[0].category.color;
        }
      } else {
      }
    })
  }
  /**
 * to get smart beauty Blog List  
 */
  async getSmartBeautyBlogList(catId: any) {
    this.mCommonListModalRequest.take = 6;
    this.mCommonListModalRequest.catagoryid = catId;
    this.smartBeautyBlogs = []
    const smartBeautyBlogs = this.wsblogservice.getAllBlogFilter(this.mCommonListModalRequest);
    await lastValueFrom(smartBeautyBlogs).then(response => {
      if (response && response.statusCode == 200) {
        this.smartBeautyBlogs = response.data;
        this.smartBeautyBlogs = this.smartBeautyBlogs.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
        })
        if (this.smartBeautyBlogs && this.smartBeautyBlogs.length > 0) {
          this.smartBeautyColor = this.smartBeautyBlogs[0].category.color;
        }
      } else {
      }
    })
  }


  /**
* to get smart beauty Blog List  
*/
  async getForMensBlogList(catId: any) {
    this.mCommonListModalRequest.take = 6;
    this.mCommonListModalRequest.catagoryid = catId;
    this.forMensBlogs = []
    const forMensBlogs = this.wsblogservice.getAllBlogFilter(this.mCommonListModalRequest);
    await lastValueFrom(forMensBlogs).then(response => {
      if (response && response.statusCode == 200) {
        this.forMensBlogs = response.data;
        this.forMensBlogs = this.forMensBlogs.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
        })
        if (this.forMensBlogs && this.forMensBlogs.length > 0) {
          this.forMensColor = this.forMensBlogs[0].category.color;
        }
      } else {
      }
    })
  }

  /**
* to get smart beauty Blog List  
*/
  async getHairBlogList(catId: any) {
    this.mCommonListModalRequest.take = 6;
    this.mCommonListModalRequest.catagoryid = catId;
    this.hairBlogs = []
    const hairBlogs = this.wsblogservice.getAllBlogFilter(this.mCommonListModalRequest);
    await lastValueFrom(hairBlogs).then(response => {
      if (response && response.statusCode == 200) {
        this.hairBlogs = response.data;
        this.hairBlogs = this.hairBlogs.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
        })
        if (this.hairBlogs && this.hairBlogs.length > 0) {
          this.hairColor = this.hairBlogs[0].category.color;
        }
      } else {
      }
    })
  }

  /**
* to get smart beauty Blog List  
*/
  async getBathBodyBlogList(catId: any) {
    this.mCommonListModalRequest.take = 6;
    this.mCommonListModalRequest.catagoryid = catId;
    this.bathBodyBlogs = []
    const bathBodyBlogs = this.wsblogservice.getAllBlogFilter(this.mCommonListModalRequest);
    await lastValueFrom(bathBodyBlogs).then(response => {
      if (response && response.statusCode == 200) {
        this.bathBodyBlogs = response.data;
        this.bathBodyBlogs = this.bathBodyBlogs.filter((item: any) => {
          if (item.is_active !== false) {
            return true;
          }
          return false;
        })
        if (this.bathBodyBlogs && this.bathBodyBlogs.length > 0) {
          this.bathBodyColor = this.bathBodyBlogs[0].category.color;
        }
      } else {
      }
    })
  }



  showShare(hide?: any) {
    if (hide == 'hide') {
      this.share = null;
    }
    else {
      if (this.share == hide.id) {
        this.share = null;
      }
      else {
        this.share = hide.id;
        this.currentUrl = decodeURI(this.baseUrl + "/individual-blog-updated/" + hide.title.split(' ').join('_') + '/' + hide.category_id + '/' + hide.id)
      }
    }
  }

  clickToCopy(copy: any) {

    const blogData = this.baseUrl + "/individual-blog-updated/" + copy.title.split(' ').join('_') + '/' + copy.category_id + '/' + copy.id;

    // Create a dummy textarea element to perform the copying
    const textarea = document.createElement('textarea');
    textarea.value = blogData;
    document.body.appendChild(textarea);

    // Select the text in the textarea
    textarea.select();
    document.execCommand('copy');

    // Clean up - remove the textarea
    document.body.removeChild(textarea);
    this._commonBehaviorChangeService.getToast('Blog Link Copied');

    this.showShare('hide');
  }


  async openBlogDetail(val: any) {
    this.searchHistory = this.getSearchHistory();
    let newSearch = this.searchHistory.filter((item: any) => item.id == val.id)
    if (newSearch == null || newSearch.length == 0) {
      this.searchHistory.unshift(val);
      if (val.title.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }
    else {
      this.searchHistory = this.searchHistory.filter((item: any) => item.id !== val.id);
      this.searchHistory.unshift(val);
      if (val.title.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }
    this.router.navigate(["/individual-blog-updated/" + val.title.split(' ').join('_') + '/' + val.category_id + '/' + val.id])
  }

  async openBlogList(categoryId: any) {
    this.router.navigate(["/blog-list/" + categoryId])
  }

  async showAllTrending() {
    this.router.navigate(["/blog-list-two"])
  }

  getImage(val: any, index?: any) {
    return 'http://img.youtube.com/vi/' + val.split('?v=')[1] + '/hqdefault.jpg'
  }

  showVideo(val: any) {
    if (this.count == 0) {
      this.foyBlogTv.sanitizeUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + val.split('?v=')[1] + '?autoplay=1');
      this.count = 1;
      return this.foyBlogTv.sanitizeUrl;
    }
  }

  getBlogThumbnail(imageList: any) {
    if (imageList.length < 1) {
      return 'assets/images/noblogimage.jpg'
    }
    var thumbnail = imageList.filter((img: any) => img.type == 'blog_thumbnail_image')
    if (thumbnail.length > 0) {
      return thumbnail[0].path;
    }
    else {
      return 'assets/images/noblogimage.jpg'
    }
  }

  clickSearch() {
    if (this.blogSearchForm.controls['search'].value == '' || this.blogSearchForm.controls['search'].value == null) {
      this.show = false;
      this.getSearchHistory();
      if (this.arrSearchHistory && this.arrSearchHistory.length > 0) {
        this.historyShow = !this.historyShow;
      }
    }
    else {
      this.historyShow = false;
      this.show = !this.show;
    }
  }

  checkAllArrow() {
    if (this.trendingblogs) {
      let container = this.trendingblogs.nativeElement;
      this.showtrendingBlogLeftArrow = container.scrollLeft > 0;
      this.showtrendingBlogRightArrow = container.scrollWidth > container.clientWidth + container.scrollLeft;
    }

    if (this.skincareone) {
      let Skincarecontainer = this.skincareone.nativeElement;
      this.showskincareoneLeftArrow = Skincarecontainer.scrollLeft > 0;
      this.showskincareoneRightArrow = Skincarecontainer.scrollWidth > Skincarecontainer.clientWidth + Skincarecontainer.scrollLeft;
    }

    if (this.decode) {
      let decodecontainer = this.decode.nativeElement;
      this.showdecodeLeftArrow = decodecontainer.scrollLeft > 0;
      this.showdecodeRightArrow = decodecontainer.scrollWidth > decodecontainer.clientWidth + decodecontainer.scrollLeft;
    }
    if (this.formen) {
      let formencontainer = this.formen.nativeElement;
      this.showformenLeftArrow = formencontainer.scrollLeft > 0;
      this.showformenRightArrow = formencontainer.scrollWidth > formencontainer.clientWidth + formencontainer.scrollLeft;
    }

    if (this.smartbeauty) {
      let smartbeautycontainer = this.smartbeauty.nativeElement;
      this.showsmartbeautyLeftArrow = smartbeautycontainer.scrollLeft > 0;
      this.showsmartbeautyRightArrow = smartbeautycontainer.scrollWidth > smartbeautycontainer.clientWidth + smartbeautycontainer.scrollLeft;
    }

    if (this.hairwego) {
      let hairwegocontainer = this.hairwego.nativeElement;
      this.showhairwegoLeftArrow = hairwegocontainer.scrollLeft > 0;
      this.showhairwegoRightArrow = hairwegocontainer.scrollWidth > hairwegocontainer.clientWidth + hairwegocontainer.scrollLeft;
    }

    if (this.editor) {
      let editorcontainer = this.editor.nativeElement;
      this.showeditorLeftArrow = editorcontainer.scrollLeft > 0;
      this.showeditorRightArrow = editorcontainer.scrollWidth > editorcontainer.clientWidth + editorcontainer.scrollLeft;
    }

    if (this.bathbody) {
      let bathbodycontainer = this.bathbody.nativeElement;
      this.showbathbodyLeftArrow = bathbodycontainer.scrollLeft > 0;
      this.showbathbodyRightArrow = bathbodycontainer.scrollWidth > bathbodycontainer.clientWidth + bathbodycontainer.scrollLeft;
    }
  }


  checkScroll(id: any) {
    switch (id) {
      case 'trendingblogs':
        let container = this.trendingblogs.nativeElement;
        this.showtrendingBlogLeftArrow = container.scrollLeft > 0;
        this.showtrendingBlogRightArrow = container.scrollWidth > container.clientWidth + container.scrollLeft;
        break;

      case 'skincareone':
        let Skincarecontainer = this.skincareone.nativeElement;
        this.showskincareoneLeftArrow = Skincarecontainer.scrollLeft > 0;
        this.showskincareoneRightArrow = Skincarecontainer.scrollWidth > Skincarecontainer.clientWidth + Skincarecontainer.scrollLeft;
        break;

      case 'decode':
        let decodecontainer = this.decode.nativeElement;
        this.showdecodeLeftArrow = decodecontainer.scrollLeft > 0;
        this.showdecodeRightArrow = decodecontainer.scrollWidth > decodecontainer.clientWidth + decodecontainer.scrollLeft;
        break;

      case 'formen':
        let formencontainer = this.formen.nativeElement;
        this.showformenLeftArrow = formencontainer.scrollLeft > 0;
        this.showformenRightArrow = formencontainer.scrollWidth > formencontainer.clientWidth + formencontainer.scrollLeft;
        break;

      case 'smartbeauty':
        let smartbeautycontainer = this.smartbeauty.nativeElement;
        this.showsmartbeautyLeftArrow = smartbeautycontainer.scrollLeft > 0;
        this.showsmartbeautyRightArrow = smartbeautycontainer.scrollWidth > smartbeautycontainer.clientWidth + smartbeautycontainer.scrollLeft;
        break;

      case 'hairwego':
        let hairwegocontainer = this.hairwego.nativeElement;
        this.showhairwegoLeftArrow = hairwegocontainer.scrollLeft > 0;
        this.showhairwegoRightArrow = hairwegocontainer.scrollWidth > hairwegocontainer.clientWidth + hairwegocontainer.scrollLeft;
        break;

      case 'editor':
        let editorcontainer = this.editor.nativeElement;
        this.showeditorLeftArrow = editorcontainer.scrollLeft > 0;
        this.showeditorRightArrow = editorcontainer.scrollWidth > editorcontainer.clientWidth + editorcontainer.scrollLeft;
        break;

      case 'bathbody':
        let bathbodycontainer = this.bathbody.nativeElement;
        this.showbathbodyLeftArrow = bathbodycontainer.scrollLeft > 0;
        this.showbathbodyRightArrow = bathbodycontainer.scrollWidth > bathbodycontainer.clientWidth + bathbodycontainer.scrollLeft;
        break;

      default:
        break;
    }
  }

  goRight(id: any) {
    var container = document.getElementById(id)
    if (container) {
      this.sideScroll(container, 'right', 10, 200, 10);
      setTimeout(() => {
        this.checkScroll(id)
      }, 1000);
    }
  }


  goLeft(id: any) {
    var container = document.getElementById(id)
    if (container) {
      this.sideScroll(container, 'left', 10, 200, 10);
      setTimeout(() => {
        this.checkScroll(id)
      }, 1000);
    }
  }

  sideScroll(element: any, direction: any, speed: any, distance: any, step: any) {
    var scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction == 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }

  commingSoon() {
    this._commonBehaviorChangeService.getToast('Skin Test will be live soon!');
  }
}